import { api } from "./client";
import type { RunDetail, RunSummary, Paged, RunStatus } from "./types";

export interface RunListParams {
  status?: RunStatus | "";
  /** "event" = event-driven only, "cron" = scheduled only, "" = all. */
  trigger?: "event" | "cron" | "";
  function_id?: string;
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export const runsApi = {
  list: (p: RunListParams = {}) =>
    api<Paged<RunSummary>>("/api/dashboard/runs", { query: { ...p } }),
  get: (id: string) => api<RunDetail>(`/api/dashboard/runs/${id}`),
  replay: (id: string) => api<{ new_run_id: string }>(`/api/dashboard/runs/${id}/replay`, { method: "POST" }),
  cancel: (id: string) => api<void>(`/api/dashboard/runs/${id}/cancel`, { method: "POST" }),
};
